import { message } from "../dialogs";

export interface FriendlyError {
    message: string;
    friendly: true;
}

/**Devuelve true si cierto objeto es una excepción amistosa */
export function isFriendlyError(x: any): x is FriendlyError {
    return typeof x == "object" && x.friendly === true && (typeof (x.message) == "string");
}

/**Ejecuta una función y muestra un mensaje de error si la exepcion que devuelve es una amistosa. Devuelve true si no hubo error */
export async function execUserFunc(func: (() => (PromiseLike<void> | void)) | undefined): Promise<boolean> {
    if (func == null) return true;
    try {
        await func();
        return true;
    } catch (error) {
        //Si el error cumple con la especificacion de error amistoso, mostramos el error al usuario
        if (isFriendlyError(error)) {
            await message("", error.message, "error");
        } else {
            console.error(error);
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./~/kea-react/src/botones/exec.ts